import {useAppDispatch, useAppSelector} from "../../../../../state/state.tsx";
import {openModal} from "../../../../../state/ModalSlice/ModalSlice.ts";
import {setAccountName, setBankAccountNumber, setIFSCCode} from "../../../../../state/ArbitrarySlice/ArbitratySlice.ts";
import emptyBankAccountsImg from "../../../../../assets/subscriptions/Empty_bankAccountsimg.png"
import { selectBankAccounts, selectActiveRole } from "../../../../../state/UserStatesV2/userSliceV2.ts";

export default function YourAccounts() {
    const Dispatch = useAppDispatch();
    const BankAccounts = useAppSelector(selectBankAccounts);
    const activeRole = useAppSelector(selectActiveRole);
    const isOwnerView = !activeRole;

    const bankAccountOptions = BankAccounts.map(bankAccount => ({
        display: bankAccount.iFSC.slice(0, 4) + "****" + bankAccount.accountNo.toString().slice(-4),
        AccountNumber: bankAccount.accountNo,
        iFSC: bankAccount.iFSC,
        accountName: bankAccount.accountName,
    }));

    const handleClickAccount = (AccountNumber: string, iFSC: string, accountName: string) => {
        if (!isOwnerView) return; // Disable account details in non-owner view
        Dispatch(openModal("ViewAccountDetails"));
        Dispatch(setBankAccountNumber(AccountNumber));
        Dispatch(setIFSCCode(iFSC));
        Dispatch(setAccountName(accountName));
    };

    function handleAddBankAccounts() {
        if (!isOwnerView) return; // Disable adding accounts in non-owner view
        Dispatch(openModal("AddBankAccountOpen"));
    }

    return (
        <div className={"rounded-xl border-[1px] border-gray-300 shadow-lg bg-white p-4 mt-6 mb-4 relative"}>
            <div className="flex justify-between items-center mb-2">
                <p className={"font-semibold text-[1.2rem]"}>Bank accounts</p>
                {!isOwnerView && (
                    <p className="text-sm text-gray-500">Switch to owner account to manage bank accounts</p>
                )}
            </div>

            <div className={"max-h-56 Accounts-container pb-4 mb-2 w-full mt-4 flex flex-col gap-4 font-semibold text-sm overflow-y-auto"}>
                {bankAccountOptions.length > 0 ? (
                    bankAccountOptions.map((option, index) => (
                        <div 
                            key={index}
                            onClick={() => handleClickAccount(option.AccountNumber, option.iFSC, option.accountName)}
                            className={`flex w-full justify-between p-1.5 rounded ${
                                isOwnerView ? 'hover:bg-gray-100 cursor-pointer' : 'cursor-default'
                            }`}
                            style={{ opacity: isOwnerView ? 1 : 0.7 }}
                        >
                            <p>{option.display}</p>
                        </div>
                    ))
                ) : (
                    <div className={"flex flex-col items-center h-full"}>
                        <div className={"flex flex-col items-center"}>
                            <img src={emptyBankAccountsImg} alt={"no bank account img"} className={"size-28"}/>
                            <p className={"text-cf_normal"}>No bank account added</p>
                            <p className={"text-cf_small text-cc_secondaryText"}>
                                {isOwnerView 
                                    ? "All bank accounts will be listed here"
                                    : "Switch to owner account to add bank accounts"
                                }
                            </p>
                        </div>

                        {isOwnerView && (
                            <button 
                                onClick={handleAddBankAccounts}
                                className={"bg-[#EEF2FD] rounded-lg mt-2.5 flex justify-center items-center py-1 px-1 w-32 border-dashed border-[#1D4ED8] border-2 cursor-pointer"}
                            >
                                <svg width="14" height="14" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.5 3V15M15.5 9L3.5 9" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span className="text-cc_brand text-xs">Add Account</span>
                            </button>
                        )}
                    </div>
                )}
            </div>

            {bankAccountOptions.length > 0 && isOwnerView && (
                <div className={"flex justify-center mt-8 absolute bottom-2 right-2"}>
                    <button 
                        onClick={handleAddBankAccounts}
                        className={"flex justify-center items-center bg-cc_brand px-2 rounded-lg p-1.5"}
                    >
                        <svg width="14" height="14" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 3V15M15.5 9L3.5 9" stroke="#F9FAFB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span className="text-white text-xs">Add Account</span>
                    </button>
                </div>
            )}
        </div>
    );
}